import InactiveCardWarningModal from 'partial/OfferManager/modules/SesameCashModule/components/InactiveCardWarningModal';
import React from 'react';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { SESAME_CASH_BALANCE } from 'types/morph.pagePosition.constants';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { Row } from 'components/Containers/Row/Row';
import './OverviewCashEnrolled.scss';
import { useEnrolledCashAccount } from 'hook/cashEnrolledHelper.hook';

import { AccountOptionsLinks } from 'components/cash/AccountOptionsLinks/AccountOptionsLinks';
import { BalanceView } from 'components/cash/BalanceView/BalanceView';
import { FrozenCardModal } from 'components/cash/FrozenCardModal/FrozenCardModal';
import { useSeenModulePixel } from 'hook/helper.hook';
import RadioCardGroup from 'components/Fragments/RadioCardGroup/RadioCardGroup';
import Label from 'components/form/Label/Label';
import { ReactComponent as ChevronRight } from 'style/_assets/icons/chevron-right.svg';
import classnames from 'classnames';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { IncompleteAccountOptions } from 'partial/OfferManager/modules/SesameCashModule/components/IncompleteAccountOptions/IncompleteAccountOptions';
import { SESAME_CASH_BOOSTER_ENHANCED_1 } from 'types/sesameCash.constants';
import {
  isBoosterEnrolled,
  isBoosterMarkettingElligible,
  isEnrolledAndFunded,
} from 'helpers/sesameCash.helpers';
import BoosterEnrollmentEntryPoint from 'partial/OfferManager/modules/BoosterEnrollmentEntryPoint';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';

const IconTransferMoney = () => (
  <div className="icon-transfer-money radio-icon" />
);
const IconPerksMoney = () => <div className="icon-payearly radio-icon" />;

export const OverviewCashEnrolled = ({
  type,
  sesameCashmodulePosition,
  sesameCashAccount,
  cashModuleVersion,
  builderManager,
  cb20GaWebFlag,
  ...props
}) => {
  const {
    handleAccountOptionsClick,
    handleSetPinClick,
    handleHowToTransferModal,
    handleTransferBalanceModal,
    frozenModalOpen,
    updateDate,
    displayBalance,
    showFundActionModule,
    showAccountOptions,
    frozenCard,
    frozenSetPin,
    handleCloseFrozenModal,
    inactiveCardWarningModalOpen,
    toggleInactiveCardWarningModal,
    onClickChat,
  } = useEnrolledCashAccount({
    sesameCashAccount,
    eventHandler: props.eventHandler,
    userInfo: props.userInfo,
  });

  const takeModalHandler = e => {
    const val = e.target.value;
    if (val === 'showPerks') {
      props.eventHandler(CLICK, {
        'Click Type': 'Learn More Perks & Benefits',
        'Module Name': SESAME_CASH_BALANCE,
        Vertical: BANKING_VERTICAL,
      });
      props.handleAccountOptionsClick(val);
    } else {
      handleAccountOptionsClick(e);
    }
  };
  const modulePosition = sesameCashmodulePosition;
  const atr = getViewModuleTrackingAttributes({
    pagePosition: SESAME_CASH_BALANCE,
    modulePosition: modulePosition,
    vertical: 'Banking',
  });
  const seenPixel = useSeenModulePixel(atr);
  const { RadioCard } = RadioCardGroup;
  let frozenSetPinCopy = '';

  if (frozenSetPin) {
    frozenSetPinCopy = 'Un-freeze to set PIN';
  }
  if (cashModuleVersion === SESAME_CASH_BOOSTER_ENHANCED_1) {
    return '';
  }

  const showBoosterEnhancement =
    cb20GaWebFlag?.config?.module_cb10_upsell?.show &&
    isBoosterMarkettingElligible(props.creditInfo) &&
    isEnrolledAndFunded(props.userInfo, sesameCashAccount) &&
    !isBoosterEnrolled(sesameCashAccount);

  if (showFundActionModule) {
    return <></>;
  }

  return (
    <>
      {seenPixel}
      <SectionContainer className="OverviewCashEnrolled">
        <Row>
          <FlexContainer className="flex-mobile-col justify-between  mobile-items-align-start ">
            <div className="balance-container">
              <BalanceView
                balance={displayBalance}
                updateDate={updateDate}
                frozenCard={frozenCard}
                frozenCardCopy={frozenSetPinCopy}
                cashModuleVersion={cashModuleVersion}
                builderManager={builderManager}
                sesameCashAccount={sesameCashAccount}
                userInfo={props.userInfo}
              />
            </div>

            <div className="padB24 desktopHide" />
            <FlexContainer
              className={classnames('flex-column cashAction-container', {
                'mformat100 format50': cashModuleVersion !== null,
              })}
            >
              {cashModuleVersion === null && showAccountOptions && (
                <AccountOptionsLinks
                  hideTransferMoney={frozenSetPin}
                  sesameCashAccount={sesameCashAccount}
                  frozenCard={frozenCard}
                  handleAccountOptionsClick={handleAccountOptionsClick}
                />
              )}
              {cashModuleVersion === null && showFundActionModule && (
                <IncompleteAccountOptions
                  sesameCashAccount={sesameCashAccount}
                  handleSetPinClick={handleSetPinClick}
                  handleHowToTransferModal={handleHowToTransferModal}
                  handleTransferBalanceModal={handleTransferBalanceModal}
                  frozenCard={frozenCard}
                />
              )}
              {cashModuleVersion !== null && (
                <>
                  <RadioCardGroup
                    onChange={takeModalHandler}
                    radioGroupClass="format100"
                  >
                    <RadioCard
                      datatestid={`fund-account-transferMoney-radio`}
                      value="transferMoney"
                      cardType="fullWidth no-margin-top"
                      icon={IconTransferMoney}
                    >
                      <FlexContainer className="justify-between align-items-center">
                        <Label>Add money to account</Label>
                        <ChevronRight aria-label="chevron-right-icon" />
                      </FlexContainer>
                    </RadioCard>
                    <RadioCard
                      datatestid={`fund-account-manageCard-radio`}
                      value="showPerks"
                      cardType="fullWidth"
                      icon={IconPerksMoney}
                    >
                      <FlexContainer className="justify-between align-items-center">
                        <Label>See perks & benefits</Label>
                        <ChevronRight aria-label="chevron-right-icon" />
                      </FlexContainer>
                    </RadioCard>
                  </RadioCardGroup>
                </>
              )}
            </FlexContainer>
          </FlexContainer>
        </Row>
      </SectionContainer>
      <FrozenCardModal
        visible={frozenModalOpen}
        onCancel={handleCloseFrozenModal}
      />
      {showBoosterEnhancement && (
        <BoosterEnrollmentEntryPoint
          {...props}
          modulePosition={modulePosition}
        />
      )}
      <InactiveCardWarningModal
        inactiveCardWarningModalOpen={inactiveCardWarningModalOpen}
        toggleInactiveCardWarningModal={toggleInactiveCardWarningModal}
        onClickChat={onClickChat}
      />
    </>
  );
};
